import { combineReducers } from 'redux'
import graph from './graph'

export default combineReducers({
    graphState: graph
})